import { useEffect, useRef, useState } from "react"
import { ProductCards } from "../../../components/ProductCard"
import { Link, useNavigate, useParams } from "react-router-dom"
import { useGlobalContext } from "@/global/GlobalContext"
import DefaultLayout from "@/layouts/Default"
import EngraveTitle from "../../../components/EngraveTitle"
import { Button } from "@/components/Button"
import Input from "@/components/input/Input"
import Slider from "react-slick"
import { formatNumber, handleError, handleNegativeVal } from "@/app/utils/helpers"
import { useForm } from "react-hook-form"
import { productSchema } from "@/app/utils/validation"
import CartAPI from "@/app/api/di-sana/cart/cart"
import DiSanaAPI from "@/app/api/di-sana/di-sana"
import { ProductCardsRowSkeleton } from "@/components/skeletons/ProductCardSkeleton"
import "@/assets/css/di-sana-product.css"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
import { loadOrderCount } from "@/app/redux/features/order/orderSlice"
import { useDispatch } from "react-redux"
import SanitizedDescription from "@/components/SanitizedDescription"
import Cookies from "js-cookie"
import { InnerZoomedImage } from "../../../components/ZoomableImage"
const cartApi = new CartAPI()
const diSanaApi = new DiSanaAPI()

const Product = () => {
  const { notifyError, notifyInfo, authStore, productDetail, products, pathname, setSeoContent, notifySuccess } = useGlobalContext()
  const { slug } = useParams();
  const { register, handleSubmit, setValue, getValues, reset } = useForm()
  const [onSaving, setOnSaving] = useState(false)
  const [disabledBtn, setDisabledBtn] = useState(false)
  const [qAmount, setQAmount] = useState(0)
  const [prefix, setPrefix] = useState("")
  const [productRecomms, setProductRecomms] = useState([])
  const layoutRef = useRef()
  const processToCart = useRef(false)
  const navigate = useNavigate()
  // const [tempSlug, setTempSlug] = useState("")
  const dispatch = useDispatch()
  const [onReq, setOnReq] = useState(true)
  const settings = {
    dots: false,
    infinite: true,
    speed: 2100,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2100,
    fade: true
  };



  useEffect(() => {
    setOnReq(true)
    loadProductRecomms(slug)
    layoutRef.current.getProductDetail(slug)
    setValue("quantity", 1)
    setQAmount(1)
    const tempPathname = pathname.split("/")
    tempPathname.pop()

    setPrefix(tempPathname.join("/"))
  }, [pathname])

  useEffect(() => {
    setOnReq(true)
    const selectedId = Cookies.get("categoryId")
    // TODO: sebelumnya, kode yg di bwh isi cek ini juga: && products.length == 0
    if (Object.keys(productDetail).length > 0) loadProduct(productDetail.product_category.id, selectedId, false, true)
    Cookies.set("categoryId", selectedId)
  }, [productDetail])

  const onSubmit = async (formData) => {
    setOnSaving(true)
    if (formData.quantity == '0' || formData <= 0) {
      notifyInfo("Please, input amount of order")
      setOnSaving(false)
      return
    }
    const err = await addCart(formData)
    if (err) {
      if (typeof err.error[0] == "string") {
        notifyError(err.error[0])
      } else {
        const newErrs = handleError(err)
        notifyError(newErrs.qty)
      }
    }
    setOnSaving(false)
  }

  const calculateQuantity = (val) => {
    let newVal = parseInt(getValues("quantity")) + parseInt(val)
    let valStr = newVal < 0 ? "0" : newVal.toString()
    setValue("quantity", valStr)

    setQAmount(parseInt(valStr))
    setDisabledBtn(newVal > productDetail.stock)
    if (newVal > productDetail.stock) return notifyError("Amount exceeds stock!")
  }

  const changeQuantity = (val) => {
    let newVal = val.charAt(0) == "0" ? val.slice(1) : val

    let valStr = newVal == "" ? 0 : handleNegativeVal(newVal)
    setDisabledBtn(val > productDetail.stock)
    if (val > productDetail.stock) return notifyError("Amount exceeds stock!")
    setValue("quantity", valStr)
    setQAmount(parseInt(valStr))
  }

  const displayDesc = (desc) => {
    return <SanitizedDescription desc={desc} custCls="font-light text-sm sm:text-xl text-[#6e6060] block mt-6" />
  }

  // API request
  const loadProduct = async (id, page, loadMore, diff) => {
    await layoutRef.current.getProductByProdCategory(id, page, loadMore, diff)
    setOnReq(false)
  }

  const loadProductRecomms = async (slug) => {
    try {
      const { data } = await diSanaApi.getProductRecomms(slug)
      setProductRecomms(data.data)
    } catch (err) {
      notifyError(err.message)
    }
  }

  const addCart = async (formData) => {
    try {
      const insertedData = productSchema.safeParse({
        qty: formData.quantity.toString(),
        // weight: productDetail.weight,
        product_id: Cookies.get("productId"),
        is_checked: processToCart.current ? 1 : 0
      })

      if (!insertedData.success) return { error: insertedData.error.issues }

      const { data } = await cartApi.addAndUpdateCart(insertedData.data)
      if (data.code == 200) {
        await dispatch(loadOrderCount()).unwrap()
        setValue("quantity", "1")
        setQAmount(1)

        if (processToCart.current) {
          navigate("/cart")
          processToCart.current = false
        } else {
          notifySuccess("Product was added to your cart!")
        }
      }
    } catch (err) {
      notifyError(err.message)
    }
  }

  return (
    <>
      <DefaultLayout ref={layoutRef}>
        {/* breadcrumbs */}
        <div className="mb-6 md:px-12 px-4 mt-12">
          <ol className="text-[#6e605d] font-agcasmlt font-light text-3xl flex">
            {onReq ? (
              <>
                <ContainerSkeleton custH="h-8" custW="w-40" custCls="mr-2" />
                <ContainerSkeleton custH="h-8" custW="w-40" />
              </>
            ) : (
              <>
                <li className="mr-2 breadcrumb"><Link to="/di-sana">Store</Link></li>
                <li className="breadcrumb active"><Link to={`/di-sana/${productDetail.product_category?.name.replaceAll(" ", "-").toLowerCase()}`} className="">{productDetail.product_category?.name}</Link></li>
              </>
            )}
          </ol>
        </div>
        <section className="md:px-12 px-4">
          <div className="lg:flex max-lg:flex-col gap-14">
            <div className="lg:w-[55%]">
              <div className="w-full">
                {/* TODO: nanti loop data photos, seharusnya ini berupa array nanti, but dari be masih single image */}
                {onReq ? (
                  <ContainerSkeleton custH="h-[500px] lg:h-[470px]" />
                ) : (
                  <>
                    <Slider {...settings} className="h-[500px] lg:h-[470px] border-2 border-[#dcd6d2] overflow-hidden">
                      <InnerZoomedImage src={productDetail.photo} alt={productDetail.name} custCls="w-full h-[500px] lg:h-[470px] object-cover flex items-center" zoomCls="zoomable-img-zoom" />
                    </Slider>
                  </>
                )}
              </div>
              <div className="max-lg:hidden mt-8">
                <span className="font-light font-agcasmlt text-sm sm:text-xl text-[#6e6060]">Description</span>
                {onReq ? (
                  <div>
                    <ContainerSkeleton custH="h-4 sm:lg:h-5" custCls="mt-6" />
                    <ContainerSkeleton custH="h-4 sm:lg:h-5" custCls="mt-1" />
                    <ContainerSkeleton custH="h-4 sm:lg:h-5" custCls="mt-1" />
                  </div>
                ) : (
                  <>
                    {/* <p className="font-light font-agcasmlt text-sm sm:text-xl text-[#6e6060] block mt-6">{productDetail && productDetail.description}</p> */}
                    {displayDesc(productDetail.description)}
                  </>
                )}
              </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="max-sm:mt-4 max-lg:mt-8 lg:w-2/5">
              <div className="flex justify-between">
                <div className="max-sm:w-[60%] max-lg:w-[70%]">
                  <h1 className="max-lg:hidden text-[#6e615a] font-light text-base sm:text-3xl md:text-4xl mb-4"><span className="uppercase font-agcasmlt mr-3">di sana</span><span className="font-sloopScriptPro">Our Shop & Cafe</span></h1>
                  <div>
                    {/* TODO: nanti cek perbedaan tampilan textnya */}
                    {onReq ? (
                      <>
                        <ContainerSkeleton custH="h-6 sm:h-8 md:h-9 lg:h-12 xl:h-16" custCls="mb-1 sm:mb-2" />
                        <ContainerSkeleton custH="h-[18px] sm:h-[30px] lg:h-[54px]" />
                      </>
                    ) : (
                      <>
                        <h1 className="text-[#6e6060] font-agcasmlt text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl sm:mb-2">{productDetail.name}</h1>
                        <span className="text-[#6e605d] font-agcasmlt font-extralight text-[18px] sm:text-[30px] lg:text-[54px] leading-none">IDR {productDetail && productDetail.price && formatNumber(productDetail.price)}</span>
                      </>
                    )}
                  </div>
                  <div className="block lg:hidden mt-4 sm:mt-8">
                    <span className="font-light font-agcasmlt text-sm sm:text-xl text-[#6e6060]">Description</span>
                    <p className="font-light font-agcasmlt text-sm sm:text-xl text-[#6e6060] block mt-1 lg:mt-3">{productDetail && productDetail.description}</p>
                  </div>
                </div>
                {/* TODO: kasih kondisi jika ini perlu tampil */}
                {/* <div className="lg:hidden max-sm:w-[25%] max-lg:w-[20%]">
                  <div className="mb-2">
                    <Select required forProduct name="material" label="Material" id="material" options={[]} custArrowCls="-z-10" />
                  </div>
                  <div>
                    <Select required forProduct name="color" label="Color" id="color" options={[]} custArrowCls="-z-10" />
                  </div>
                </div> */}
              </div>
              <div className="mt-6 mb-14">
                <div className="mb-5">
                  <Input disabled={onReq || onSaving} defaultValue={qAmount} noValue calculateQuantityVal={(val) => calculateQuantity(val)} onInputVal={changeQuantity} spinner custCls="w-[30%] md:w-[20%] lg:w-1/3" ref={{ ...register("quantity") }} />
                </div>
                {/* TODO: kasih kondisi jika ini perlu tampil */}
                {/* <div className="hidden lg:block mb-5 w-1/3">
                  <div className="mb-2">
                    <Select required forProduct name="material" label="Material" id="material" options={[]} custArrowCls="-z-10" />
                  </div>
                  <div>
                    <Select required forProduct name="color" label="Color" id="color" options={[]} custArrowCls="-z-10" />
                  </div>
                </div> */}
                <div className="w-[50%] md:w-[40%] lg:w-3/5">
                  {authStore.isAuth ? (
                    <>
                      <div className="mb-2.5">
                        <Button type="submit" title="Add to cart" disabled={disabledBtn || onReq} isSaving={onSaving} onlyBorder custCls="border-[#dcd6d2] text-lg sm:text-xl lg:text-2xl font-light pt-2 pb-1" />
                      </div>
                      <div>
                        <Button processBtn type="submit" onClickBtn={() => processToCart.current = true} title="Buy it now" disabled={disabledBtn || onReq || onSaving} isSaving={onSaving && processToCart.current} custCls="text-lg sm:text-xl lg:text-2xl font-extralight pt-2 pb-1" />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="mb-2.5 w-full">
                        <Link to="/auth/login" className="block text-center border-[#dcd6d2] text-lg sm:text-xl lg:text-2xl font-light pt-2 pb-1 w-full border-2 text-[#6e6060] font-agcasmlt">Add to cart</Link>
                      </div>
                      <div className="w-full">
                        <Link to="/auth/login" className="block text-center text-lg sm:text-xl lg:text-2xl font-extralight pt-2 pb-1 w-full border-2 text-white font-agcasmlt border-[#6e6060] bg-[#6e6060]">Buy it now</Link>
                      </div>
                    </>
                  )
                  }
                </div>
              </div>
              {/* TODO: nanti loop star berdasarkan jumlah review per 100% kyknya gini rumusnya */}
              {/* TODO: pakai star yg solid untuk skor genap, sama half kalo ada setengah perhintungannya, misal 1 bintang = solid, 1/2 bintang: half */}
              {/* <div className="flex gap-10 items-center">
                <div>
                  <span className="font-light font-agcasmlt text-sm sm:text-xl text-[#6e6060]">Customer Review <span className="ml-1 text-sm">1/5</span></span>
                  <div className="block mt-1">
                    <FontAwesomeIcon icon={faStar} size="sm" className="text-[#6e6060] font-light mr-1" />
                    <FontAwesomeIcon icon={faStar} size="sm" className="text-[#6e6060] font-light mr-1" />
                    <FontAwesomeIcon icon={faStar} size="sm" className="text-[#6e6060] font-light mr-1" />
                    <FontAwesomeIcon icon={faStar} size="sm" className="text-[#6e6060] font-light mr-1" />
                    <FontAwesomeIcon icon={faStar} size="sm" className="text-[#6e6060] font-light mr-1" />
                  </div>
                </div>
                <div className="w-1/3">
                  <Button title="Write a review" custCls="text-lg font-extralight tracking-wide pt-1.5 pb-0.5" />
                </div>
              </div> */}
            </form>
          </div>
        </section>
        <section className="pb-4">
          <EngraveTitle title="You May Also Like" />
          {onReq ? (
            productRecomms.length <= 0 && <ProductCardsRowSkeleton count={3} />
          ) : (
            productRecomms.length > 0 ?
              <ProductCards products={productRecomms} prefix={prefix} onReq={onReq} count={3} />
              :
              <p className="text-center text-gray-500">No product available.</p>
          )}
        </section>
      </DefaultLayout>
    </>
  )
}

export default Product